import styled from "styled-components";
import { EyeInvisibleOutlined } from "@ant-design/icons";

export const NotVisibleIcon = styled(EyeInvisibleOutlined)`
  color: ${({ theme }) => theme.colors.blueDianne};
`;
